export default "__VITE_ASSET__B3YN$vHf__"